<div class="backgroundColor shark darken-4">
  <section class="position-relative top-119 backgroundColor shark darken-4">
    <div class="container pt-32 pb-5">
      <div class="row">
        <div class="col-12 col-xs-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 mx-auto card-color card-border">
          <div class="row col-12 text-center my-5">
            <div class="row mx-auto" *ngIf="first">
              <h2 class="textColor white base">Password temporaria, recomenda-se a sua alteração</h2>
            </div>ll
            <div class="row mx-auto">
              <i class="fad fa-user-lock fa-10x textColor mine-shaft lighten-1"></i>
            </div>
          </div>
          <div class="row col-12 my-1">
            <div class="form-group col-12 mx-auto">
              <label class="textColor harvest-gold base">Password Atual</label>&nbsp;
              <input class="form-control" type="password" [(ngModel)]="old">
            </div>
          </div>
          <div class="row col-12 my-1">
            <div class="form-group col-12 mx-auto">
              <label class="textColor harvest-gold base">Nova Password</label>&nbsp;
              <input class="form-control" type="password" [(ngModel)]="pass">
            </div>
          </div>
          <div class="row col-12 my-1">
            <div class="form-group col-12 mx-auto">
              <label class="textColor harvest-gold base">Confirme a Nova Password</label>&nbsp;
              <input class="form-control" type="password" [(ngModel)]="confirm">
            </div>
          </div>
          <div class="row col-12 my-1 mb-3 mt-4">
            <button class="btn btn-grad px-8 ml-3 mb-3 mr-5" (click)="send()">Submeter</button>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>